import { __decorate } from "tslib";
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { IDLE_TIMESTAMP, IDLE_TIMESTAMP_TO } from '@/helpers/constants/app';
import { Getter } from 'vuex-class';
import moment from 'moment';
import LogoutMixin from './LogoutMixin';
let IdleListenerMixin = class IdleListenerMixin extends Mixins(LogoutMixin) {
    constructor() {
        super(...arguments);
        this.toggleSessionExpiredDialog = false;
        this.maxTimeMinutes = 5;
    }
    resetElapsedTime() {
        if (this.storedToken) {
            this.setSessionTimestamp();
            this.setSessionMaxTimestamp();
        }
    }
    setSessionTimestamp() {
        localStorage.setItem(IDLE_TIMESTAMP, `${moment().unix()}`);
    }
    setSessionMaxTimestamp() {
        localStorage.setItem(IDLE_TIMESTAMP_TO, `${moment().add(this.maxTimeMinutes, 'minutes').unix()}`);
    }
    isIdleWithinMaxSeconds() {
        const unixTimestamp = +(localStorage.getItem(IDLE_TIMESTAMP) || '');
        const unixMaxTimestamp = +(localStorage.getItem(IDLE_TIMESTAMP_TO) || '');
        return unixTimestamp >= unixMaxTimestamp;
    }
    initIdleTimer() {
        this.resetElapsedTime();
        window.onload = this.resetElapsedTime;
        window.onmousemove = this.resetElapsedTime;
        window.onmousedown = this.resetElapsedTime;
        window.ontouchstart = this.resetElapsedTime;
        window.onclick = this.resetElapsedTime;
        window.onkeypress = this.resetElapsedTime;
        window.onscroll = this.resetElapsedTime;
        this.timerFunction();
    }
    timerFunction() {
        const nSeconds = 1000;
        const timer = window.setInterval(async () => {
            if (this.isIdleWithinMaxSeconds()) {
                // Temporary fix for login issue
                // await this.destroyToken(this.storedToken);
                await this.logout();
                clearInterval(timer);
            }
            if (this.storedToken) {
                this.setSessionTimestamp();
            }
        }, nSeconds);
        return timer;
    }
    storedTokenListener(newValue) {
        if (newValue) {
            // this.initIdleTimer();
            // window.onblur = this.timerFunction;
        }
        else {
            this.removeSessionTimestamps();
            window.onblur = null;
        }
    }
};
__decorate([
    Getter('token', { namespace: 'session' })
], IdleListenerMixin.prototype, "storedToken", void 0);
__decorate([
    Watch('storedToken', { immediate: true })
], IdleListenerMixin.prototype, "storedTokenListener", null);
IdleListenerMixin = __decorate([
    Component
], IdleListenerMixin);
export default IdleListenerMixin;
